import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
import Animation from '../animation';
import formatMessage from '../../format-message';
import { alert } from '../../utilities/alertUtils';
export var FocusItemOnSave =
/*#__PURE__*/
function (_Animation) {
  _inherits(FocusItemOnSave, _Animation);

  function FocusItemOnSave() {
    _classCallCheck(this, FocusItemOnSave);

    return _possibleConstructorReturn(this, _getPrototypeOf(FocusItemOnSave).apply(this, arguments));
  }

  _createClass(FocusItemOnSave, [{
    key: "fixedElement",
    value: function fixedElement() {
      return this.app().fixedElementForItemScrolling();
    }
  }, {
    key: "uiDidUpdate",
    value: function uiDidUpdate() {
      var action = this.acceptedAction('SAVED_PLANNER_ITEM');
      var savedItemUniqueId = action.payload.item.uniqueId;
      var itemComponentToFocus = this.registry().getComponent('item', savedItemUniqueId);

      if (itemComponentToFocus != null) {
        if (!action.payload.wasToggled) {
          this.animator().focusElement(itemComponentToFocus.component.getFocusable('update'));
        }

        this.maintainViewportPositionOfFixedElement();
        this.animator().scrollTo(itemComponentToFocus.component.getScrollable(), this.stickyOffset());
      } else {
        alert(formatMessage('Success: To Do created'));
      }
    }
  }]);

  return FocusItemOnSave;
}(Animation);